import BaseModel from '../base/BaseModel.model';
import ProposalScheduleGanttActivity from './ProposalScheduleGanttActivity.model';
export default class ProposalScheduleGanttPhase extends BaseModel {

    public order: number = 0;
    public percentDone: number = 0;
    public percentDoneUI: number = 0;
    public taskName: string = null;
    public taskId: string = null;
    public resource: string = null;
    public dependencies: string = null;
    public porposalId: number = 0;
    public startDate: Date | null = null;
    public endDate: Date | null = null;
    public proposalScheduleGanttActivities:Array<ProposalScheduleGanttActivity> = [];

    init() {
        this.order = 0;
        this.percentDone = 0;
        this.taskName = null;
        this.taskId = null;
        this.resource = null;
        this.dependencies = null;
        this.PorposalId = 0;
        this.startDate = null;
        this.endDate = null;
    }
}